export const enPosSystem = {
  hero: {
    title: "POS System with Web and Mobile App",
    subtitle: "Complete point of sale system with web and mobile applications",
    imageAlt: "POS system interface showing checkout screen"
  },
  features: {
    salesManagement: {
      title: "Sales Management",
      description: "Complete sales processing with receipts, returns, exchanges, and refunds"
    },
    inventory: {
      title: "Inventory Control",
      description: "Real-time stock tracking with low stock alerts and automated reordering"
    },
    multiPlatform: {
      title: "Multi-Platform Support",
      description: "Web dashboard, iOS and Android apps with offline capabilities"
    },
    coupons: {
      title: "Promotions Engine",
      description: "Create and manage discount coupons, loyalty programs, and seasonal promotions"
    },
    suppliers: {
      title: "Vendor Management",
      description: "Track suppliers, manage purchase orders, and handle vendor payments"
    },
    reporting: {
      title: "Advanced Analytics",
      description: "Generate detailed sales reports, business insights, and financial analytics"
    }
  },
  techStack: {
    title: "Technology Stack",
    backend: {
      title: "Backend",
      laravel: "Laravel 11 framework for robust operations",
      php: "PHP 8.2+ with JIT compilation",
      architecture: "API-first microservices architecture"
    },
    frontend: {
      title: "Frontend",
      web: "React.js with Next.js for web dashboard",
      mobile: "Flutter 3 for cross-platform mobile apps",
      state: "Redux for state management"
    },
    integrations: {
      title: "Integrations",
      payments: "Stripe, Square, and POS hardware integrations",
      accounting: "QuickBooks and Xero accounting software",
      ecommerce: "Shopify and WooCommerce connectors"
    }
  },
  dashboard: {
    title: "Powerful POS Dashboard",
    description: "Complete control over your retail operations with real-time sales monitoring",
    demoAlt: "POS system admin dashboard preview",
    features: {
      "1": "Unified web and mobile interfaces",
      "2": "Real-time sales and inventory tracking",
      "3": "Advanced reporting and analytics",
      "4": "Multi-location management",
      "5": "Staff performance monitoring"
    }
  },
  cta: {
    title: "Ready to Modernize Your POS System?",
    description: "Discover how our solution can streamline your retail operations and boost sales",
    buttonText: "View Demo",
    buttonAriaLabel: "View demo of the POS system"
  }
};


export const frPosSystem = {
  hero: {
    title: "Système de point de vente avec application Web et mobile",
    subtitle: "Système complet de point de vente avec applications Web et mobiles",
    imageAlt: "Interface du système de point de vente montrant l'écran de paiement"
  },
  features: {
    salesManagement: {
      title: "Gestion des ventes",
      description: "Traitement complet des ventes avec reçus, retours, échanges et remboursements"
    },
    inventory: {
      title: "Contrôle des stocks",
      description: "Suivi des stocks en temps réel avec alertes de faible stock et réapprovisionnement automatisé"
    },
    multiPlatform: {
      title: "Support multi-plateforme",
      description: "Tableau de bord Web, applications iOS et Android avec capacités hors ligne"
    },
    coupons: {
      title: "Moteur de promotions",
      description: "Créer et gérer des coupons de réduction, des programmes de fidélité et des promotions saisonnières"
    },
    suppliers: {
      title: "Gestion des fournisseurs",
      description: "Suivre les fournisseurs, gérer les commandes d'achat et traiter les paiements des fournisseurs"
    },
    reporting: {
      title: "Analytique avancée",
      description: "Générer des rapports de vente détaillés, des informations commerciales et des analyses financières"
    }
  },
  techStack: {
    title: "Technologie Stack",
    backend: {
      title: "Backend",
      laravel: "Framework Laravel 11 pour des opérations robustes",
      php: "PHP 8.2+ avec compilation JIT",
      architecture: "Architecture microservices axée sur l'API"
    },
    frontend: {
      title: "Frontend",
      web: "React.js avec Next.js pour le tableau de bord Web",
      mobile: "Flutter 3 pour des applications mobiles multiplateformes",
      state: "Redux pour la gestion de l'état"
    },
    integrations: {
      title: "Intégrations",
      payments: "Intégrations Stripe, Square et matériel POS",
      accounting: "Logiciels de comptabilité QuickBooks et Xero",
      ecommerce: "Connecteurs Shopify et WooCommerce"
    }
  },
  dashboard: {
    title: "Tableau de bord POS puissant",
    description: "Contrôle total de vos opérations de vente au détail avec surveillance des ventes en temps réel",
    demoAlt: "Aperçu du tableau de bord administrateur du système POS",
    features: {
      "1": "Interfaces Web et mobiles unifiées",
      "2": "Suivi des ventes et des stocks en temps réel",
      "3": "Rapports et analyses avancés",
      "4": "Gestion multi-sites",
      "5": "Suivi des performances du personnel"
    }
  },
  cta: {
    title: "Prêt à moderniser votre système POS?",
    description: "Découvrez comment notre solution peut rationaliser vos opérations de vente au détail et augmenter vos ventes",
    buttonText: "Voir la démo",
    buttonAriaLabel: "Voir la démo du système POS"
  }
};

export const nlPosSystem = {
  hero: {
    title: "POS-systeem met web- en mobiele app",
    subtitle: "Compleet kassasysteem met web- en mobiele applicaties",
    imageAlt: "POS-systeem interface toont afrekenscherm"
  },
  features: {
    salesManagement: {
      title: "Verkoopbeheer",
      description: "Volledige verkoopverwerking met bonnen, retouren, omruilingen en terugbetalingen"
    },
    inventory: {
      title: "Voorraadbeheer",
      description: "Realtime voorraadtracking met lage voorraadmeldingen en automatische herbestellingen"
    },
    multiPlatform: {
      title: "Multi-platform ondersteuning",
      description: "Webdashboard, iOS- en Android-apps met offline mogelijkheden"
    },
    coupons: {
      title: "Promotie Engine",
      description: "Maak en beheer kortingsbonnen, loyaliteitsprogramma's en seizoensgebonden promoties"
    },
    suppliers: {
      title: "Leveranciersbeheer",
      description: "Volg leveranciers, beheer inkooporders en verwerk betalingen aan leveranciers"
    },
    reporting: {
      title: "Geavanceerde Analytics",
      description: "Genereer gedetailleerde verkooprapporten, zakelijke inzichten en financiële analyses"
    }
  },
  techStack: {
    title: "Technologiestack",
    backend: {
      title: "Backend",
      laravel: "Laravel 11 framework voor robuuste operaties",
      php: "PHP 8.2+ met JIT-compilatie",
      architecture: "API-first microservices architectuur"
    },
    frontend: {
      title: "Frontend",
      web: "React.js met Next.js voor webdashboard",
      mobile: "Flutter 3 voor cross-platform mobiele apps",
      state: "Redux voor state management"
    },
    integrations: {
      title: "Integraties",
      payments: "Stripe, Square en POS-hardware integraties",
      accounting: "QuickBooks en Xero boekhoudsoftware",
      ecommerce: "Shopify en WooCommerce connectors"
    }
  },
  dashboard: {
    title: "Krachtig POS-dashboard",
    description: "Volledige controle over uw retailactiviteiten met realtime verkoopmonitoring",
    demoAlt: "Preview van POS-systeem admin dashboard",
    features: {
      "1": "Geïntegreerde web- en mobiele interfaces",
      "2": "Realtime verkoop- en voorraadtracking",
      "3": "Geavanceerde rapportage en analytics",
      "4": "Multi-locatie beheer",
      "5": "Personeelsprestatie monitoring"
    }
  },
  cta: {
    title: "Klaar om uw POS-systeem te moderniseren?",
    description: "Ontdek hoe onze oplossing uw retailactiviteiten kan stroomlijnen en de verkoop kan verhogen",
    buttonText: "Bekijk Demo",
    buttonAriaLabel: "Bekijk demo van het POS-systeem"
  }
};

export const dePosSystem = {
  hero: {
    title: "POS-System mit Web- und Mobile-App",
    subtitle: "Komplettes Kassensystem mit Web- und mobilen Anwendungen",
    imageAlt: "POS-System-Oberfläche zeigt Checkout-Bildschirm"
  },
  features: {
    salesManagement: {
      title: "Verkaufsmanagement",
      description: "Komplette Verkaufsabwicklung mit Quittungen, Rückgaben, Umtausch und Rückerstattungen"
    },
    inventory: {
      title: "Bestandskontrolle",
      description: "Echtzeit-Bestandsverfolgung mit Niedrigbestandswarnungen und automatischer Nachbestellung"
    },
    multiPlatform: {
      title: "Multi-Plattform-Unterstützung",
      description: "Web-Dashboard, iOS- und Android-Apps mit Offline-Funktionen"
    },
    coupons: {
      title: "Promotion Engine",
      description: "Erstellen und verwalten Sie Rabattcoupons, Treueprogramme und saisonale Aktionen"
    },
    suppliers: {
      title: "Lieferantenmanagement",
      description: "Lieferanten verfolgen, Bestellungen verwalten und Lieferantenbezahlungen abwickeln"
    },
    reporting: {
      title: "Erweiterte Analytik",
      description: "Detaillierte Verkaufsberichte, Geschäftseinblicke und Finanzanalysen generieren"
    }
  },
  techStack: {
    title: "Technologie-Stack",
    backend: {
      title: "Backend",
      laravel: "Laravel 11 Framework für robuste Abläufe",
      php: "PHP 8.2+ mit JIT-Kompilierung",
      architecture: "API-First-Microservices-Architektur"
    },
    frontend: {
      title: "Frontend",
      web: "React.js mit Next.js für das Web-Dashboard",
      mobile: "Flutter 3 für plattformübergreifende mobile Apps",
      state: "Redux für State Management"
    },
    integrations: {
      title: "Integrationen",
      payments: "Stripe, Square und POS-Hardware-Integrationen",
      accounting: "QuickBooks und Xero Buchhaltungssoftware",
      ecommerce: "Shopify und WooCommerce Konnektoren"
    }
  },
  dashboard: {
    title: "Leistungsstarkes POS-Dashboard",
    description: "Vollständige Kontrolle über Ihre Einzelhandelsaktivitäten mit Echtzeit-Verkaufsüberwachung",
    demoAlt: "Vorschau des POS-System-Admin-Dashboards",
    features: {
      "1": "Vereinheitlichte Web- und Mobile-Interfaces",
      "2": "Echtzeit-Verkaufs- und Bestandsverfolgung",
      "3": "Erweiterte Berichte und Analytik",
      "4": "Multi-Standort-Management",
      "5": "Mitarbeiterleistungsüberwachung"
    }
  },
  cta: {
    title: "Bereit, Ihr POS-System zu modernisieren?",
    description: "Erfahren Sie, wie unsere Lösung Ihre Einzelhandelsaktivitäten optimieren und den Umsatz steigern kann",
    buttonText: "Demo ansehen",
    buttonAriaLabel: "Demo des POS-Systems ansehen"
  }
};